import React from "react";
import { Input } from "@teals/ui-web";
import {
  StepContent,
  TypeCard,
  TypeCardIcon,
  TypeCardTitle,
  TypeCardDesc,
} from "../styles";
import { DetailSectionTitle } from "../styles";
import {
  DS_TYPE_LABELS,
  DS_TYPE_DESCRIPTIONS,
  DS_TYPE_ICONS,
} from "../constants";
import type { DsType } from "../../../store/api/dataSourcesApi";

interface StepSelectTypeProps {
  name: string;
  onNameChange: (val: string) => void;
  description: string;
  onDescriptionChange: (val: string) => void;
  selectedType: DsType;
  onTypeChange: (type: DsType) => void;
}

const DS_TYPES: DsType[] = [
  "search_index",
  "blob_storage",
  "unstructured_store",
  "byo",
];

const StepSelectType: React.FC<StepSelectTypeProps> = ({
  name,
  onNameChange,
  description,
  onDescriptionChange,
  selectedType,
  onTypeChange,
}) => {
  return (
    <StepContent>
      <Input
        label="Name"
        placeholder="e.g. Product Catalog"
        required
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
      />
      <Input
        label="Description (optional)"
        placeholder="Brief description of this data source"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
      />
      <DetailSectionTitle>Select data source type</DetailSectionTitle>
      {DS_TYPES.map((type) => (
        <TypeCard
          key={type}
          $selected={type === selectedType}
          onClick={() => onTypeChange(type)}
        >
          <TypeCardIcon>{DS_TYPE_ICONS[type]}</TypeCardIcon>
          <div>
            <TypeCardTitle>{DS_TYPE_LABELS[type]}</TypeCardTitle>
            <TypeCardDesc>{DS_TYPE_DESCRIPTIONS[type]}</TypeCardDesc>
          </div>
        </TypeCard>
      ))}
    </StepContent>
  );
};

export default StepSelectType;
